export default __webpack_public_path__ + "static/media/480_business01-it-mobile.892640bc.png";